import React from 'react';
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Auth from '../../../../../common/auth';
import Util from '../../../../../common/util';

import { setCode } from '../../../../../actions/core';
import { setReturnTo } from '../../../../../actions/return';

import LeftRail from '../../../shared/components/left-rail';
import PageHeader from '../../../shared/components/page-header';
import PopAlert from '../../../shared/components/pop-alert';
import StandardInput from '../../../shared/components/standard-input';

const styles = (theme) => ({
  link: {
    cursor: "pointer"
  },
  view: {
    ...theme.internalContainer,
    [theme.breakpoints.up('md')]: {
      padding: theme.internalContainer._themeMdPadding
    },
  },
  pageContainer: theme.pageContainer,
});

class View extends React.Component {

  constructor(props) {

    super(props);

    this.state = {
      code: this.props.code || '',
      processing: false,
      redeemed: false,
      redirect: null,
      validation: {
        code: null
      }
    };

    this.generateOnInput = this.generateOnInput.bind(this);
    this.onError = this.onError.bind(this);
    this.onReturnHome = this.onReturnHome.bind(this);
    this.onSubmitPressed = this.onSubmitPressed.bind(this);
    this.redeemCode = this.redeemCode.bind(this);
    this.redirect = this.redirect.bind(this);
  }

  async componentWillMount() {
    if (this.props.code) {
      await Auth.userValidate(this.props.dispatch);

      await this.redeemCode();
    }
  }

  generateOnInput(stateKey) {

    return function (e) {

      this.setState({
        [stateKey]: e.target.value,
        validation: { code: null }
      });
    }.bind(this);
  }

  onError(errObj) {

    this.setState({ processing: false });
    this.props.onError(errObj);
  }

  onReturnHome() {
    this.redirect('/');
  }

  async onSubmitPressed(e) {

    if (e.key === 'Enter') {
      await this.redeemCode();
    }
  }

  async redeemCode() {
    // Redeem code logic here

    const exists = await Auth.checkPasscode(this.props.dispatch, this.state.code);

    if (!exists) {
      this.setState({
        validation: {
          code: 'The code you entered is invalid. Please try again.'
        }
      });
      return;
    }

    if (this.props.code && this.props.user.hasValidated && this.props.user.isSignedIn) {
      this.setState({ processing: true });
      const result = await Auth.userRedeemPasscode(this.props.dispatch, this.state.code);

      if (result === true) {
        this.setState({ processing: false, redeemed: true });
        return;
      }

      this.setState({
        processing: false,
        validation: {
          code: result.content.message
        }
      });

      this.props.dispatch(setCode(null));
    } else {
      // Set code in state
      this.props.dispatch(setReturnTo(`/code`));
      this.props.dispatch(setCode(this.state.code));
      await Auth.userLogout(this.props.dispatch);
      this.setState({ redirect: '/' });
    }
  }

  redirect(redirect) {
    this.setState({ redirect });
  }

  render() {
    if (this.state.redirect !== null) {
      return (
        <Redirect to={this.state.redirect} />
      );
    }

    let view = (
      <Grid item xs={12} md={6}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PageHeader text={'Enter Code'} />
            <Typography color="textPrimary" className={this.props.classes.text}>Enter the code that appears on your TV.</Typography>
          </Grid>
          <Grid item xs={12}>
            <StandardInput
              inputType="email"
              value={this.state.code}
              style={{ marginBottom: '32px' }}
              error={this.state.validation.code}
              attribute="code"
              label="CODE"
              focus={true}
              onChange={this.generateOnInput('code')}
              onKeyUp={this.onSubmitPressed} />
          </Grid >
          <Grid item xs={12}>
            <Button color="primary" onClick={this.redeemCode} variant="contained">
              {this.state.processing ?
                (<CircularProgress size={14} color="inherit" />)
                : 'Next'
              }
            </Button>
          </Grid>
        </Grid>
      </Grid>
    );

    if (this.state.redeemed) {
      view = (
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <PageHeader text={'Code Redeemed'} />
              <Typography color="textPrimary" className={this.props.classes.text}>Your device has been successfully logged in.  Your TV will update momentarily..</Typography>
            </Grid>
            <Grid item xs={12}>
              <Button color="primary" onClick={this.onReturnHome} variant="contained">Return home
              </Button>
            </Grid>
          </Grid>
        </Grid>
      );
    }

    return (
      <div className={this.props.classes.pageContainer}>
        <Grid container spacing={0} className={this.props.classes.view}>
          <PopAlert open={this.state.pop} message={this.state.error} onClose={this.onRequestClose} />
          <Grid item xs={12} md={6}>
            <LeftRail />
          </Grid>
          {view}
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    code: state.code,
    error: state.error,
    flow: state.flow,
    user: Auth.userState(state)
  };
}

const ConnectedView = connect(mapStateToProps, null)(View);

export default withStyles(styles)(ConnectedView);
